import { type QueryHookOptions, useQuery } from "@apollo/client";
import { DisputesListQuery } from "../graphql/queries";
import type {
  DisputesListQueryType,
  DisputesListQueryVariablesType,
} from "@/types/graphql/admin.generated";

export const useDisputesQuery = (
  options?: QueryHookOptions<
    DisputesListQueryType,
    DisputesListQueryVariablesType
  >
) => {
  return useQuery<DisputesListQueryType, DisputesListQueryVariablesType>(
    DisputesListQuery,
    options
  );
};
